import { globalReactService } from '@commons'
import { getCookie } from './cookies.helper'

export const getJwtFromCookies = () => {
  let cookieKey = 'rankmi_jwt'
  const { defaultSubDomain } = globalReactService

  cookieKey =
    defaultSubDomain && defaultSubDomain.match(/^app$/g)
      ? cookieKey
      : `rankmi_${defaultSubDomain}_jwt`

  return getCookie(cookieKey)
}
